// Rishab code
import React, { useState, useEffect } from "react";
import "../addTicketPage/AddTicketPage.scss";
import BreadCrumb from "../../../components/breadCrumb/BreadCrumb";
import SaveNewHeader from "../../../components/customPageHeader/SaveNewHeader";
import CustomTextBox from "../../../components/customTextBox/CustomTextBox";
import CustomDropdown from "../../../components/customDropDown/CustomDropdown";
import CustomHtmlEditor from "../../../components/customHtmlEditor/CustomHtmlEditor";
import { priorityDataSource, statusDataSource2 } from "../data";
import { fetchCustomerData } from "../../../api/companyCustomerApi";
import { ToastDisplayer } from "../../../components/toastDisplay/ToastDisplayer";
import { useAuth } from "../../../contexts/auth";
import { FileUploader, LoadPanel } from "devextreme-react";
import {
  getcustcategory,
  getPriorityApi,
  postSaveTicket,
} from "../../../api/ticketApi";
import { fetchSubcategories, getCategoryData } from "../../../api/settingsApi";
import { useNavigate } from "react-router-dom";
import { fetchCustomerContacts } from "../../../api/companyCustomerApi";

export default function AddTicketPage() {
  const { user } = useAuth();
  const [ticketData, setTicketData] = useState({
    ticketsubject: "",
    ticketdescription: "",
    ticketcategorytransid: "",
    ticketsubcattransid: "",
    companytransid: "",
    ticketstatus: "",
    ticketpriority: "",
    ticketdatetime: "",
    usertransid: "",
    username: "",
    customertransid: "",
    ticketcreatedby: "",
    contacttransid: "",
  });

  const [customerDataSource, setCustomerDataSource] = useState([]);
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [subcategoryOptions, setSubcategoryOptions] = useState([]);
  const [filteredSubcategories, setFilteredSubcategories] = useState([]);
  const [markup, setMarkup] = useState("");
  const [loading, setLoading] = useState(true);
  const TIMESTAMP = new Date().toISOString();
  const [errors, setErrors] = useState({});
  const [fileError, setFileError] = useState(null);
  const navigate = useNavigate();
  const [notesAttachedFile, setNotesAttachedFile] = useState("");
  const [categoryData, setCategoryData] = useState([]);
  const [contactDataSource, setContactDataSource] = useState([]);
  const [priorityDataSource, setPriorityDataSource] = useState([]);

  useEffect(() => {
    loadPriorities();
  }, []);

  const loadPriorities = async () => {
    try {
      const result = await getPriorityApi();

      const formatted = result.map((item) => ({
        value: item.id, // ✅ use id
        text: item.name, // ✅ use name
      }));

      setPriorityDataSource(formatted);
    } catch (error) {
      ToastDisplayer("error", "Failed to load priorities");
    }
  };
  const fetchCategories = async (companytransid, customertransid) => {
    try {
      setLoading(true);
      let response = await getcustcategory(companytransid, customertransid);

      const categoryData1 = response.category_subcategory_mappings.map(
        (category) => ({
          value: category.category_id,
          text: category.category_name,
          subcategories: (category.subcategories || [])
            .filter((sub) => sub !== null) // ✅ remove nulls
            .map((subcategory) => ({
              value: subcategory.subcategory_id,
              text: subcategory.subcategory_name,
            })),
          //   subcategories: category.subcategories.map((subcategory) => ({
          //     value: subcategory.subcategory_id,
          //     text: subcategory.subcategory_name,
          //   })),
        }),
      );

      setCategoryData(categoryData1);
      setCategoryOptions(categoryData1);

      if (ticketData.ticketcategorytransid) {
        const selectedCategory = categoryData1.find(
          (category) => category.value === ticketData.ticketcategorytransid,
        );

        setFilteredSubcategories(selectedCategory?.subcategories || []);
      }
    } catch (error) {
      if (user?.userrole != "customer") {
        ToastDisplayer(
          "error",
          error.response?.data?.msg || "Failed to fetch categories",
        );
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (user?.userrole === "customer" || ticketData.customertransid) {
      fetchCategories(
        user?.companytransid,
        ticketData.customertransid || user?.customertransid,
      );
    }
  }, [
    user?.userrole,
    user?.companytransid,
    ticketData.customertransid,
    ticketData.ticketcategorytransid,
  ]);

  useEffect(() => {
    if (user?.userrole === "customer") {
      fetchCategories();
    } else {
      return;
    }
  }, [
    user?.userrole,
    user?.companytransid,
    user?.customertransid,
    ticketData.ticketcategorytransid,
  ]);

  useEffect(() => {
    if (ticketData.ticketcategorytransid) {
      const selectedCategory = categoryOptions.find(
        (category) => category.value === ticketData.ticketcategorytransid,
      );

      if (selectedCategory) {
        setFilteredSubcategories(selectedCategory.subcategories);
      } else {
        setFilteredSubcategories([]);
      }
    } else {
      setFilteredSubcategories([]);
    }
  }, [ticketData.ticketcategorytransid, categoryOptions]);

  useEffect(() => {
    const loadCustomerData = async () => {
      try {
        setLoading(true);
        const res = await fetchCustomerData(user?.companytransid);
        if (res?.data?.length > 0) {
          const mappedData = res.data.map((customer) => ({
            value: customer.transid,
            text: customer.custname,
          }));
          // console.log("Mapped Data : ", mappedData);
          setCustomerDataSource(mappedData);
        }
      } catch (error) {
        ToastDisplayer("error", "Failed to fetch customer data.");
      } finally {
        setLoading(false);
      }
    };
    loadCustomerData();
  }, [user, user?.userrole]);

  const handleInputChange = (field) => (e) => {
    // const value = e?.value || e?.target?.value || "";
    const value = e && (e.value || e.target?.value || " ");
    setTicketData((prevData) => ({
      ...prevData,
      [field]: value,
    }));
  };

  const validateForm = () => {
    const newErrors = {};

    if (!ticketData.ticketsubject) {
      newErrors.ticketsubject = "Subject is required.";
    }

    if (!ticketData.ticketcategorytransid) {
      newErrors.ticketcategorytransid = "Category is required.";
    }

    if (filteredSubcategories.length > 0 && !ticketData.ticketsubcattransid) {
      newErrors.ticketsubcattransid = "Sub-Category is required.";
    }

    if (user?.userrole !== "customer" && !ticketData.customertransid) {
      newErrors.customertransid = "Customer is required.";
    }

    if (user?.userrole !== "customer" && !ticketData.ticketstatus) {
      newErrors.ticketstatus = "Status is required.";
    }

    if (!ticketData.ticketpriority) {
      newErrors.ticketpriority = "Priority is required.";
    }

    if (!ticketData.ticketdescription) {
      newErrors.ticketdescription = "Description is required.";
    }
    if (user?.userrole === "customer" && !ticketData.contacttransid) {
      newErrors.contacttransid = "Please select Contact.";
    }

    setErrors(newErrors);
    Object.values(newErrors).forEach((error) => {
      ToastDisplayer("error", error);
    });
    return Object.keys(newErrors).length === 0;
  };

  const handleSaveDetails = async () => {
    if (fileError) {
      ToastDisplayer("error", fileError); // Show the file error
      return; // Prevent further execution if file validation failed
    }
    if (!validateForm()) return;
    try {
      setLoading(true);
      const resolvedUsername =
        user?.username || (user?.email ? user.email.split("@")[0] : "");

      let modifiedData = {
        ...ticketData,
        ticketpriority_fk: ticketData.ticketpriority,
        ticketdescription: markup,
        ticketdatetime: TIMESTAMP,
        companytransid: user?.companytransid,
        ticketcreatedby:
          user?.userrole === "customer"
            ? user?.custcode
            : user?.userrole === "company"
              ? user?.companytransid
              : user?.cmpusercode,
        ticketattachedfile: notesAttachedFile,
      };

      if (user?.userrole === "customer") {
        const customerTransId = user?.customertransid;
        if (customerTransId) {
          modifiedData.customertransid = customerTransId;
          modifiedData.contacttransid = ticketData.contacttransid;
          modifiedData.ticketstatus = "Open"; /// by default customer created ticket status should be open
          delete modifiedData.usertransid;
          delete modifiedData.username;
        }
      } else {
        modifiedData = {
          ...modifiedData,
          usertransid: user?.usertransid,
          username: resolvedUsername,
          ticketstatus: ticketData.ticketstatus,
        };
      }

      // uncomment
      const res = await postSaveTicket(modifiedData);
      if (res.message === "Ticket saved successfully!") {
        ToastDisplayer("success", "Ticket saved successfully.");
        navigate("/Ticket");
      }
    } catch (error) {
      ToastDisplayer(
        "error",
        error.response?.data?.errors?.non_field_errors || error.message,
      );
    } finally {
      setLoading(false);
    }
  };

  const getDropdownLabel = (dataSource, selectedId) => {
    if (!selectedId) return ""; // Return an empty string to show the placeholder
    const selectedItem = dataSource.find((item) => item.value === selectedId);
    return selectedItem ? selectedItem.text : "";
  };

  const handleCancel = () => {
    navigate(-1);
  };

  const handleFileChange = async (e) => {
    const file = e.value[0];
    if (!file) {
      setFileError(null);
      setNotesAttachedFile(null);
      return;
    }

    const allowedTypes = [
      "image/png",
      "image/jpeg",
      "image/jpg",
      "application/pdf",
    ];
    const maxSize = 1.5 * 1024 * 1024; // 1.5MB limit

    let error = null;

    // Check for invalid file type
    if (!allowedTypes.includes(file.type)) {
      error = "Invalid file type! Please upload a PNG, JPG, JPEG, or PDF file.";
    }

    // Check for file size exceeding the limit
    if (file.size > maxSize) {
      error = "File size exceeds 1.5MB! Please upload a smaller file.";
    }

    // If error, set the error state and clear the file input
    if (error) {
      setFileError(error);
      setNotesAttachedFile(null); // Clear file input
      return;
    }

    // When the file is valid
    setFileError(null);
    const reader = new FileReader();
    reader.onload = () => {
      setNotesAttachedFile(reader.result);
    };
    reader.readAsDataURL(file);
  };

  useEffect(() => {
    if (user?.userrole === "customer") {
      loadContacts();
    }
  }, [user?.userrole]);

  const loadContacts = async () => {
    try {
      const result = await fetchCustomerContacts();

      if (result.success) {
        const formattedContacts = result.data.map((item) => ({
          text: item.contactname, // shown in dropdown
          value: item.transid, // sent to API
        }));

        setContactDataSource(formattedContacts);
      } else {
        ToastDisplayer("error", result.message);
      }
    } catch (error) {
      ToastDisplayer("error", "Failed to load contacts");
    }
  };

  return (
    <>
      {loading && <LoadPanel visible={loading} />}
      <div className="addTicPage">
        <SaveNewHeader
          titleName="Add Tickets"
          handleSaveDetails={handleSaveDetails}
          handleSaveNew={handleCancel}
        />
        <div className="crumbMargin">
          <BreadCrumb />
        </div>
        <div className="mainAddTicSection">
          <div className="leftSec">
            {user?.userrole === "customer" && (
              <CustomDropdown
                label="From"
                placeholder="Select Contact"
                myDataSource={contactDataSource}
                value={ticketData.contacttransid}
                setSelectedValue={(value) =>
                  handleInputChange("contacttransid")({
                    value: value.value,
                  })
                }
                displayValue={getDropdownLabel(
                  contactDataSource,
                  ticketData.contacttransid,
                )}
              />
            )}
            <CustomTextBox
              label="Subject"
              placeholder="Add the Subject"
              type="text"
              value={ticketData.ticketsubject}
              onChange={handleInputChange("ticketsubject")}
            />
            <div className="descSec">
              <label className="descLabel">
                Description <span className="requiredClass">*</span>
              </label>
              <CustomHtmlEditor
                markup={markup}
                setMarkup={(updatedMarkup) => {
                  setMarkup(updatedMarkup);
                  setTicketData((prev) => ({
                    ...prev,
                    ticketdescription: updatedMarkup,
                  }));
                }}
              />
            </div>
          </div>
          <div className="rightSec">
            {user?.userrole !== "customer" && (
              <>
                {/* <CustomDropdown
                  label="Customer"
                  placeholder="Select Customer"
                  myDataSource={customerDataSource}
                  value={ticketData.customertransid}
                  setSelectedValue={(value) =>
                    handleInputChange("customertransid")({ value: value.value })
                  }
                  displayValue={getDropdownLabel(
                    customerDataSource,
                    ticketData.customertransid
                  )}
                /> */}
                <CustomDropdown
                  label="Customer"
                  placeholder="Select Customer"
                  myDataSource={customerDataSource}
                  value={ticketData.customertransid}
                  setSelectedValue={(value) => {
                    handleInputChange("customertransid")({
                      value: value.value,
                    });
                    if (value.value) {
                      fetchCategories(user?.companytransid, value.value);
                    }
                  }}
                  displayValue={getDropdownLabel(
                    customerDataSource,
                    ticketData.customertransid,
                  )}
                />
                <CustomDropdown
                  label="Status"
                  placeholder="Select Status"
                  myDataSource={statusDataSource2}
                  value={ticketData.ticketstatus}
                  setSelectedValue={(value) => {
                    // console.log("Value : ",value);
                    handleInputChange("ticketstatus")({ value: value?.value });
                  }}
                  displayValue={getDropdownLabel(
                    statusDataSource2,
                    ticketData.ticketstatus,
                  )}
                />
              </>
            )}
            <CustomDropdown
              label="Priority"
              placeholder="Select Priority"
              myDataSource={priorityDataSource}
              value={ticketData.ticketpriority}
              setSelectedValue={(value) =>
                handleInputChange("ticketpriority")({ value: value.value })
              }
              displayValue={
                ticketData.ticketpriority
                  ? getDropdownLabel(
                      priorityDataSource,
                      ticketData.ticketpriority,
                    )
                  : ""
              }
            />
            {/* <CustomDropdown
              label="Category"
              placeholder="Select Category"
              myDataSource={categoryOptions}
              value={ticketData.ticketcategorytransid}
              setSelectedValue={(value) =>
                handleInputChange("ticketcategorytransid")({
                  value: value.value,
                })
              }
              displayValue={getDropdownLabel(
                categoryOptions,
                ticketData.ticketcategorytransid
              )}
            /> */}
            <CustomDropdown
              label="Category"
              placeholder="Select Category"
              myDataSource={categoryData}
              value={ticketData.ticketcategorytransid}
              setSelectedValue={(value) =>
                handleInputChange("ticketcategorytransid")({
                  value: value.value,
                })
              }
              displayValue={getDropdownLabel(
                categoryData,
                categoryData.ticketcategorytransid,
              )}
            />

            {/* {filteredSubcategories.length > 0 && (
              <CustomDropdown
                label="Sub-Category"
                placeholder="Select Sub-Category"
                myDataSource={filteredSubcategories}
                value={ticketData.ticketsubcattransid}
                setSelectedValue={(value) =>
                  handleInputChange("ticketsubcattransid")({
                    value: value.value,
                  })
                }
                displayValue={getDropdownLabel(
                  filteredSubcategories,
                  ticketData.ticketsubcattransid
                )}
              />
            )} */}

            {filteredSubcategories.length > 0 && (
              <CustomDropdown
                label="Sub-Category"
                placeholder="Select Sub-Category"
                myDataSource={filteredSubcategories}
                value={ticketData.ticketsubcattransid}
                setSelectedValue={(value) =>
                  handleInputChange("ticketsubcattransid")({
                    value: value.value,
                  })
                }
                displayValue={getDropdownLabel(
                  filteredSubcategories,
                  ticketData.ticketsubcattransid,
                )}
              />
            )}

            <div className="notesItem">
              <label className="noteDrawerLabel">Upload Attachment</label>
              <FileUploader
                className="noteFileSec"
                multiple={false}
                maxFileSize={5000000}
                allowCanceling={true}
                allowedFileExtensions={[".jpg", ".jpeg", ".pdf", ".png"]}
                // labelText="Formats: JPG, PNG, JPEG, PDF"
                onValueChanged={handleFileChange}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
